var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo, useState, useRef } from 'react';
var defaultWidthClasses = 'w-56 h-56';
var defaultMaskSrcEncoded = "data:image/svg+xml,%3Csvg width='262' height='262' viewBox='0 0 262 262' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 45.0042C0 20.1491 20.1491 0 45.0042 0H262V216.996C262 241.851 241.851 262 216.996 262H0V45.0042Z' fill='%230074BD'/%3E%3C/svg%3E";
var defaultInverseMaskSrcEncoded = "data:image/svg+xml,%3Csvg width='358' height='357' viewBox='0 0 358 357' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.5 0.5H312.996C337.575 0.5 357.5 20.4252 357.5 45.0042V355.916H45.0042C20.4252 355.916 0.5 335.991 0.5 311.412V0.5Z' fill='%230074BD'/%3E%3C/svg%3E%0A";
export default function SquareBackgroundClipPath(_a) {
    var imageObject = _a.imageObject, _b = _a.widthClasses, widthClasses = _b === void 0 ? defaultWidthClasses : _b, index = _a.index, _c = _a.isDirectionRight, isDirectionRight = _c === void 0 ? false : _c, positionClasses = _a.positionClasses;
    var _d = useState(false), isOnHover = _d[0], setIsOnHover = _d[1];
    var videoRef = useRef(null);
    var maskSrcToUse = !isDirectionRight
        ? defaultMaskSrcEncoded
        : defaultInverseMaskSrcEncoded;
    var mediaSrc = imageObject.src, imageAlt = imageObject.alt, placeholderImage = imageObject.placeholder, videoType = imageObject.type;
    var isImage = useMemo(function () { return imageObject.src.includes('jpg') || imageObject.src.includes('png'); }, [imageObject.src]);
    var gifSrc = useMemo(function () { return (isOnHover ? placeholderImage : mediaSrc); }, [isOnHover]);
    var isGif = useMemo(function () { return !isImage && imageObject.src && imageObject.src.includes('gif'); }, [isImage, imageObject.src]);
    var styleObject = {
        maskImage: "url(\"" + maskSrcToUse + "\")",
        WebkitMaskImage: "url(\"" + maskSrcToUse + "\")",
        maskRepeat: "no-repeat",
        maskPosition: "center center",
        maskClip: 'fill-box',
        WebkitMaskClip: 'fill-box',
        WebkitMaskSize: 'cover',
    };
    var setIsOnHoverHandler = function (booleanValue) {
        setIsOnHover(booleanValue);
        if (!isGif && !isImage) {
            var methodToApply = booleanValue ? 'pause' : 'play';
            if (videoRef) {
                videoRef.current[methodToApply]();
            }
        }
    };
    return isImage ? (_jsx("img", { className: widthClasses + " image-shapes__item image-shapes__item-" + index + " " + positionClasses + " image", src: mediaSrc, alt: imageAlt, style: styleObject }, void 0)) : isGif ? (_jsx(_Fragment, { children: _jsx("div", __assign({ className: "relative image-shapes__item image-shapes__item-" + index, style: __assign({ backgroundImage: "url(" + placeholderImage + ")" }, styleObject) }, { children: _jsx("div", { className: widthClasses + " image-shapes__item image-shapes__item-" + index + " " + positionClasses + " bg-cover bg-center block", style: __assign({ backgroundImage: "url(" + gifSrc + ")" }, styleObject) }, void 0) }), void 0) }, void 0)) : (
    // onMouseEnter={() => setIsOnHoverHandler(true)}
    // onMouseLeave={() => setIsOnHoverHandler(false)}
    _jsx("div", __assign({ className: widthClasses + " image-shapes__item image-shapes__item-" + index + " " + positionClasses + " relative", style: styleObject }, { children: _jsx("video", __assign({ className: 'absolute h-full min-w-full left-0 m-auto max-w-fit right-0 top-0', ref: videoRef, loop: true, poster: placeholderImage, playsInline: true, autoPlay: true, muted: true }, { children: _jsx("source", { src: mediaSrc, type: videoType }, void 0) }), void 0) }), void 0));
}
